import { MindItem, StudyflixMindItem, VideoMindItem } from '@kimuno/api-sdk/lib/types/responses/MindItem';

export function isVideoItem(mindItem: MindItem): mindItem is MindItem<'video'> {
  return mindItem.fileType === 'video';
}

export function isStudyflixMindItem(mindItem: StudyflixMindItem | VideoMindItem): mindItem is StudyflixMindItem {
  return 'studyflixVideo' in mindItem;
}
